import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { defaultContacts } from '../../helpers/defaults';
import { MatDialogRef } from '@angular/material/dialog';
import { FinalStatusService } from '../../../../services/final-status.service';
import { StepService } from '../../services/step.service';
import { ModalService } from '../../../../services/modal-service.service';
import { IContacts, IContactsUpdate } from '../../interfaces/IContacts';
import { Icons } from '../../../../components/modal-alert/enums';
import { buildContacts } from '../../helpers/code-helper';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-contacts',
  templateUrl: './update-contacts.component.html',
  styleUrls: ['./update-contacts.component.scss']
})
export class UpdateContactsComponent implements OnInit {

  forma!: FormGroup;

  contacts = defaultContacts;

  loading = false;
  templateSuffix = environment.templateSuffix;

  constructor(
    private fb: FormBuilder, private dialogRef: MatDialogRef<UpdateContactsComponent>,
    private finalService: FinalStatusService,
    private stepService: StepService,
    private modalService: ModalService

  ) {
    this.initForm();
  }

  initForm() {

    this.forma = this.fb.group({
      metodos: new FormArray([])
    });

    this.addCheckBox();

  }

  addCheckBox() {
    this.contacts.forEach((ele) => this.formAsArray.push(this.fb.control(false)));
  }

  get formAsArray() {
    return this.forma.controls['metodos'] as FormArray;
  }

  ngOnInit(): void {
    this.finalService.getContacts(this.stepService.data.idKeycloak!).subscribe({
      next: (resp) => this.validateRespContacts(resp),
      error: () => {
        this.showAlertError('Ha ocurrido un error al obtener los medios de contacto');
      }
    });
  }

  validateRespContacts(data: IContacts) {
    const contactsControl = this.formAsArray.controls;
    contactsControl.forEach((control, index) => control.setValue(data.contact[index].isCheck));
  }

  isThereNoChecks() {
    const array = this.forma.get('metodos')!.value;
    return !array.some((ele: boolean) => ele === true);
  }

  save() {
    this.loading = true;
    const array = this.forma.get('metodos')!.value;

    const email = array[0];
    const sms = array[1];
    const whats = array[2];

    const body: IContactsUpdate = buildContacts(this.stepService.data.idKeycloak!, email, sms, whats);

    this.finalService.updateContacts(body).subscribe({
      next: () => this.showAlertSuccess('Medios de contacto actualizados'),
      error: () => this.showAlertError('Ha ocurrido un error al actualizar')
    });

  }

  //

  showAlertError(msg: string) {
    this.loading = false;
    this.dialogRef.close(null);
    this.modalService.showAlertWithoutIds(msg, Icons.error, false);
  }

  showAlertSuccess(msg: string) {
    this.loading = false;
    this.dialogRef.close(null);
    this.modalService.showAlertWithoutIds(msg, Icons.success, false);
  }

}
